// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState } from 'vuex';
import individualDiagCode from '../../vue/IndividualDiagCode.vue';
import individualVehicleControlHistory from '../../vue/IndividualVehicleControlHistory.vue';
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';

export default {
  name: "IndividualDtcVch",
  data() {
    return {
      fromRoute: null, // 遷移元ルート情報（VCH取得開始時に使用）
      diagApiStatus: { feature: '', status: '' }, // 子コンポーネントのAPI通信状態
      showVch: false, // DTC初期化完了後にVCHコンポーネントを表示するためのフラグ
    };
  },

  components: {
    'individual-diag-code': individualDiagCode,
    'individual-vehicle-control-history': individualVehicleControlHistory,
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from;
      // DTCコンポーネントの beforeRouteProcess を手動呼び出し
      vm.$nextTick(() => {
        if (vm.$refs.dtcComponent) {
          vm.$refs.dtcComponent.beforeRouteProcess(vm.$refs.dtcComponent, from);
        }
      });
    });
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
    }),
  },

  methods: {
    /**
     * 通信ステータス変更ハンドラ
     * @param {object} diagStatus 子コンポーネントの通信ステータス
     */
    handleDiagApiStatusChange(diagStatus) {
      // 現時点では、個別診断DTC情報取得のステータスのみを使用するので、その他のステータスは無視する
      if (diagStatus.feature !== 'dtc') return; 
      // 個別診断DTC情報取得が成功しても失敗しても VCH 処理には移行する（error の状態でも VCH 取得処理へ移行）
      if (diagStatus.status === 'error' || diagStatus.status === 'completed') {
        if (!this.showVch) {
          this.showVch = true; // DTC通信完了後にVCHコンポーネントを表示
          this.$nextTick(() => {
            if (this.$refs.vchComponent && this.fromRoute) {
              this.$refs.vchComponent.beforeRouteProcess(this.$refs.vchComponent, this.fromRoute);
            }
          });
        }
      }
      this.diagApiStatus = diagStatus;
    },
  },

  created() {
    // イベントログのページビューカウント
    eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_DTC_VCH);
  },


  // 画面遷移時、ポーリング中か判定し、遷移許可 or 警告ダイアログ表示
  beforeRouteLeave(to, from, next) {
    // ログアウト時はポーリングを停止して遷移を許可
    if ((to.name === "login") && (to.fullPath === "/") && (to.path === "/")) {
      // 各 component の後処理は components 側の beforeUnmount で実施されるため本処理では実施しない
      next();
      return;
    }
    // ポーリング中（Stopボタンが見えている間）は移動不可
    if (this.diagApiStatus.status === 'polling') {
      this.$refs.dtcComponent?.inExecutionAlert?.();
      return;
    }
    next();
  },
};
